import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Toast } from 'primeng/toast';

@Component({
    selector: 'app-root',
    template: `<p-toast /><router-outlet />`,
    imports: [RouterOutlet, Toast]
})
export class AppComponent
{
}